import { DatePipe } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { IconComponent, NotificationComponent } from '@zero/shared/ui-web-design-system';
import { EnrolledDevice } from '@zero/shared/util-models';
import { DataService, UserMessagesHolderService } from '@zero/shared/util-web-app-services';
import { AppTanEnrollmentComponent } from '../app-tan-enrollment/app-tan-enrollment.component';
import { AppTanRetirementComponent } from '../app-tan-retirement/app-tan-retirement.component';

@Component({
  selector: 'self-service-apptan-admin',
  templateUrl: './app-tan-administration.component.html',
  imports: [
    AppTanRetirementComponent,
    AppTanEnrollmentComponent,
    DatePipe,
    NgbTooltipModule,
    IconComponent,
    NotificationComponent,
    TranslocoPipe,
  ],
})
export class AppTanAdministrationComponent implements OnInit {
  public currentEnrolledDevices?: EnrolledDevice[];
  public deviceRegMode = false;
  public deviceToDelete?: EnrolledDevice;

  readonly #dataService = inject(DataService);
  readonly #msgService = inject(UserMessagesHolderService);
  readonly #destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.#msgService.clearAllMessages();
    this.#dataService
      .getEnrolledDevices$()
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((devices) => (this.currentEnrolledDevices = devices));
  }

  public startDeviceReg(): void {
    this.deviceRegMode = true;
  }

  public regCanceledOrFinished(): void {
    this.deviceRegMode = false;
  }

  public setDeviceToDelete(device: EnrolledDevice): void {
    this.deviceToDelete = device;
  }

  public cancelDeviceDeletion(): void {
    this.deviceToDelete = undefined;
  }
}
